import { Component, OnInit, isDevMode } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthService } from './services/Auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  title1 = 'angular-idle-timeout';
  showLayout = false;

  constructor(
    private router: Router,
    private AuthService: AuthService,
    private idle: Idle,
    private keepalive: Keepalive
  ) {
    const token = localStorage.getItem('token');
    this.showLayout = !!token;

    idle.setIdle(1);
    idle.setTimeout(300);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    if (token) {
      idle.watch();
    } else {
      idle.stop();
    }

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.signOut();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
    });

    keepalive.interval(15);
    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.AuthService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        this.showLayout = true;
        idle.watch();
        this.timedOut = false;
      } else {
        this.showLayout = false;
        idle.stop();
      }
    });
  }

  ngOnInit() {
    if (isDevMode()) {
      console.log('Development!');
    } else {
      console.log('Production!');
    }
  }

  title = 'admin';

  signOut() {
    this.AuthService.logout().subscribe(() => {
      let myItem = window.localStorage.getItem('user##');
      window.localStorage.clear();
      if (myItem) {
        window.localStorage.setItem('user##', myItem);
      }
      this.idle.stop();
      this.router.navigate(['/']).then(() => {
        window.location.reload();
      });
    });
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}
